import { apiSlice } from './apiSlice';

export const customerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllCustomers: builder.query({
      query: () => ({
        url: `/api/customers`,
        method: 'GET',
      }),
      transformResponse: (response) => response.customers, // directly return customers array
      providesTags: ['Customers'],
    }),
    getCustomerById: builder.query({
      query: (customerId) => ({
        url: `/api/customers/${customerId}`,
        method: 'GET',
      }),
      transformResponse: (response) => response.customer, // directly return the customer object
      providesTags: (result, error, customerId) => [{ type: 'Customer', id: customerId }],
    }),

    getCustomerLLMConfigurationById: builder.query({
      query: (customerId) => ({
        url: `/api/customerLLMConfig/${customerId}`,
        method: 'GET',
      }),
      transformResponse: (response) => response,
      providesTags: (result, error, customerId) => [{ type: 'Customer', id: customerId }],
    }),

    createCustomer: builder.mutation({
      query: (newCustomer) => ({
        url: `/api/customers`,
        method: 'POST',
        body: newCustomer,
      }),
      invalidatesTags: ['Customers'],
    }),
    updateCustomer: builder.mutation({
      query: ({ customerId, ...updatedCustomer }) => ({
        url: `/api/customers/${customerId}`,
        method: 'PUT',
        body: updatedCustomer,
      }),
      invalidatesTags: (result, error, { customerId }) => [
        { type: 'Customer', id: customerId }, // Invalidate the specific customer
        'Customers', // Invalidate the list of customers
      ],
    }),

    regenerateSecretKey: builder.mutation({
      query: ({ customerId, keyType }) => ({
        url: `/api/customers/${customerId}/regenerate-secret`,
        method: 'POST',
        body: { key_type: keyType },
      }),
      invalidatesTags: (result, error, { customerId }) => [
        { type: 'Customer', id: customerId }, // Invalidate the specific customer
        'Customers', // Invalidate the list of customers
      ],
    }),
    getSystemDefaultPrompt: builder.query({
      query: () => '/api/system-default-prompt',
      providesTags: ['SystemPrompt'],
    }),
  }),
});

export const {
  useGetAllCustomersQuery,
  useGetCustomerByIdQuery,
  useGetCustomerLLMConfigurationByIdQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useRegenerateSecretKeyMutation,
  useGetSystemDefaultPromptQuery,
} = customerApiSlice;
